import { useEffect, useState } from 'react'
import _ from 'lodash'

const useRouteParameters = ( route ) => {
	
	const getParams = () => {
		return _.get( route, [ 'params' ], false );
	}
	
	const [ parameters, setParameters ] = useState( getParams() );
	
	useEffect(() => {
		const updatedParameters = getParams();
		if( !_.isEqual( updatedParameters, parameters ) ){
			setParameters( updatedParameters );
		}
	}, [ route ] )
	
	return parameters;
}

export default useRouteParameters
